import { gql, MutationTuple, useMutation } from '@apollo/client';

import { publicGraphQLURL } from '../../../../config';

export const GET_FIREBASE_TOKEN = gql`
  mutation getFirebaseToken($email: NonEmptyString!, $token: NonEmptyString!) {
    getFirebaseToken(email: $email, token: $token) {
      token
    }
  }
`;

interface IGetFirebaseTokenParams {
  email: string;
  token: string;
}

interface IGetFirebaseTokenResponse {
  token: string;
}

export const useMutationGetFirebaseToken = (): MutationTuple<IGetFirebaseTokenResponse, IGetFirebaseTokenParams> =>
  useMutation<IGetFirebaseTokenResponse, IGetFirebaseTokenParams>(GET_FIREBASE_TOKEN, {
    context: {
      uri: publicGraphQLURL,
    },
  });
